import GalaxyHero from "@/components/feature/GalaxyHero";

export default function Home() {
  return (
    <main className="bg-black text-white">
      <GalaxyHero />
    </main>
  );
}